<emperor-button [uiButtonType]="EmperorUIButtonTypes.Text" (click)="onClick()"
  ><div class="button-content">CONFIGURE<emperor-icon name="pencil_3_1"></emperor-icon></div
></emperor-button>
